import { getApiEndpoint } from './config/newgenome-config';

const COOKIE_NAME = 'newgenomepro-cookie';

function parseCookies() {
  return Object.fromEntries(document.cookie.split(';').map(c => {
    const [k, ...v] = c.trim().split('=');
    return [k, v.join('=')];
  }));
}

function setCookie(id, expiryMs) {
  const value = `${id}|${expiryMs}`;
  document.cookie = `${COOKIE_NAME}=${value}; path=/; expires=${new Date(expiryMs).toUTCString()}; samesite=strict`;
}

function notifyBackend(id) {
  if (!id) return;
  try {
    fetch(getApiEndpoint('webserverCookie'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cookieId: id })
    }).catch((err) => {
      console.error('webserver-cookie error', err);
    });
  } catch (err) {
    console.error('webserver-cookie error', err);
  }
}

function getCookie() {
  const all = parseCookies();
  const val = all[COOKIE_NAME];
  if (val) {
    const [id, expiry] = val.split('|');
    return { id, expiry: parseInt(expiry, 10) };
  }
  return null;
}

export function ensureNewGenomeProCookie() {
  const cookie = getCookie();
  if (cookie) {
    notifyBackend(cookie.id);
    return cookie;
  }
  const id = Math.random().toString(36).substring(2, 10);
  const expiry = Date.now() + 180 * 24 * 60 * 60 * 1000;
  setCookie(id, expiry);
  notifyBackend(id);
  return { id, expiry };
}

export function getCookieDaysLeft() {
  const cookie = getCookie();
  if (!cookie) {
    return 0;
  }
  const diff = cookie.expiry - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

export function getCookieId() {
  const cookie = getCookie();
  return cookie ? cookie.id : null;
}
